/* global axios */
import ApiClient from '../ApiClient';

class McpServersAPI extends ApiClient {
  constructor() {
    super('captain/mcp_servers', { accountScoped: true });
  }

  testConnection(mcpServerData) {
    return axios.post(`${this.url}/test_connection`, mcpServerData);
  }

  getTools(mcpServerId) {
    return axios.get(`${this.url}/${mcpServerId}/tools`);
  }

  testTool(mcpServerId, toolName, toolArgs) {
    return axios.post(`${this.url}/${mcpServerId}/test_tool`, {
      tool_name: toolName,
      tool_args: toolArgs,
    });
  }
}

export default new McpServersAPI();
